<template>
	<LayoutBase>
		<header id="content__header">
			<UserCard v-if="resource.creator" :user="resource.creator" :borderless="true"></UserCard>

			<router-link :to="{ name: 'intelligence-preview', params: { intelligence_id: resource.id }}" class="btn btn--primary"
			             v-if="resource.can.edit">Edit
			</router-link>
		</header>
		<ul class="grid post-details">
			<li v-if="resource.createdAt" class="col-6 col-md-3 detail">
				<span class="label">Posted</span>
				<span class="h3"><SvgIcon :icon="'calendar'" /> {{ resource.createdAt }}</span>
			</li>
			<li v-if="resource.dealType" class="col-12 col-md-3 detail">
				<span class="label">Deal Type</span>
				<span class="h3"><SvgIcon :icon="'deal'" /> {{ resource.dealType }}</span>
			</li>
			<li v-if="resource.sectors" class="col-12 col-md-9 detail">
				<span class="label">Sectors</span>
				<span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
			</li>
		</ul>
		<div class="card" v-if="resource.content">
			<div class="header">Intel</div>
			<div v-html="resource.content"></div>
		</div>
	</LayoutBase>
</template>

<script>
	import LayoutBase from '../Layout/LayoutBase';
	import API from '../../api';
	import SvgIcon from '../SvgIcon';
	import ResourceView from '../ResourceView';
	import UserCard from '../User/UserCard';

	export default {
		name: 'IntelligenceView',
		mixins: [ResourceView],
		components: {
			UserCard,
			LayoutBase,
			SvgIcon,
		},
        watch: {
            id: function (newVal, oldVal) {
                return API.getIntelligence(newVal).then(response => {
                    console.log("[IntelligenceView.vue] - ", response);
                    this.resource = response;
                });
            }
        },
		methods: {
			fetchResource() {
				return API.getIntelligence(this.id);
			}
		},
	}
</script>
<style lang="scss" scoped>
	#content{
		#content__header{
			justify-content: space-between;
			align-items: center;
		}
	}

	.post-details{
		margin-bottom: 3rem;
	}
</style>
